"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.fetchAsJson = fetchAsJson;
exports.fetchAsPlainText = fetchAsPlainText;
exports.putAsJson = putAsJson;
exports.postAsJson = postAsJson;
exports.postAsPlainText = postAsPlainText;
exports.setHandle401RequestCallback = setHandle401RequestCallback;
exports.setHandleStatusCallback = setHandleStatusCallback;
exports.deleteAsJson = deleteAsJson;
exports.setGlobalModifyHeader = setGlobalModifyHeader;
exports.globalModifyHeader = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _has = _interopRequireDefault(require("lodash/has"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _objectHelper = require("./object-helper");

var _fetch = _interopRequireDefault(require("./../fetch"));

var _urlHelper = require("./url-helper");

var _runtimeConfigHelper = require("./runtime-config-helper");

var _useDataApi = require("../hooks/useDataApi");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

if (typeof window !== 'undefined' && !window.AbortController) {
  Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2["default"])(require('abortcontroller-polyfill'));
  });
}

var onHandle401Request;
var onHandleStatus;
var globalModifyHeader = null;
exports.globalModifyHeader = globalModifyHeader;

function _internalFetch(url, options, dispatch, getState) {
  var didCallDispatch = false;
  /**
   * innerDispatch - helper that calls dispatch and adds some other logic
   *
   * @param {object} body to dispatch
   * @param {bool} success false if we want to throw an error
   * @param {Response} response
   * @param {boolean} didThrowException
   */

  var innerDispatch = function innerDispatch(body, success, response, didThrowException) {
    var dispatchType = success ? "".concat(options.key, "_FULFILLED") : "".concat(options.key, "_ERROR");

    if (body && options.convertToCamelCase) {
      body = (0, _objectHelper.snakeToCamelCaseObject)(body);
    }

    var name = !success ? 'error' : '';
    didCallDispatch = true;

    try {
      dispatch({
        type: dispatchType,
        body: body,
        name: name,
        extraArguments: options.extraArguments,
        response: response
      });
    } catch (ex) {
      console.log("exception in reducer ".concat(dispatchType, ": ").concat(ex.message));
      throw ex;
    }

    if (onHandleStatus && !options.skipStatusCallback) {
      onHandleStatus(response.status, body);
    }

    if (!success) {
      if (!options.dontShowErrorsInNotificationBar && body.message && !didThrowException) {
        console.error("Call failed from server: ".concat(options.key, ": ").concat(body.message));
        console.error('url: ' + url);
        console.error(body);

        if (window) {
          if (response.status !== 402) {
            // Don't show for Payment error status 402
            // Pass the message to the notification bar to show the error message
            window.postMessage({
              type: 'fetch_notification',
              message: body.message
            }, window.document.origin);
          }
        }
      }

      if (options.onError) {
        options.onError(body, dispatch, getState);
      }
    }
  };

  dispatch({
    type: "".concat(options.key, "_PENDING"),
    extraArguments: options.extraArguments
  }); // fake result for testing

  if (options.fakeSuccess) {
    setTimeout(function () {
      innerDispatch(options.fakeSuccess, true);
    }, options.fakeTimeout || 1500);
    return;
  } // fake result for testing


  if (options.fakeError) {
    setTimeout(function () {
      innerDispatch(options.fakeError, false);
    }, options.fakeTimeout || 1500);
    return;
  }

  if (options.cancelObject) {
    var controller = new AbortController();

    options.cancelObject.abort = function () {
      return controller.abort();
    };

    options.signal = controller.signal;
    options.dontShowErrorsInNotificationBar = true;
  }

  var responsePromise = (0, _fetch["default"])(url, _objectSpread({}, options, {
    url: url,
    skipCredentials: (0, _urlHelper.isKnownCdnUrl)(url) || options.skipCredentials
  })).then(function (response) {
    return _checkAuthentication(response, url, options);
  });
  responsePromise = responsePromise.then(function (res) {
    // Convert response to text and return original response + data
    return res.text().then(function (data) {
      return {
        response: res,
        data: data
      };
    });
  });

  if (options.appendPromise) {
    responsePromise = responsePromise.then(options.appendPromise);
  }

  return responsePromise.then(function (result) {
    var obj = {
      response: result.response,
      payload: result.data
    }; // Check if returnType is defined, if not, skip the 'parsing' and fallback to text

    if (typeof options.returnType === 'undefined' || options.returnType === null || options.returnType === '') {
      return obj;
    } // Convert text to the return type (only JSON supported for now)


    if (options.returnType === 'json') {
      if (obj.payload.length > 0) {
        obj.payload = JSON.parse(obj.payload);

        if (options.convertToCamelCase) {
          obj.payload = (0, _objectHelper.snakeToCamelCaseObject)(obj.payload);
        }
      }
    } else if (options.returnType === 'text') {
      return obj;
    } else {
      // Or... Returntype was defined, but not supported yet, throw a message
      console.log("Returntype ".concat(options.returnType, " not supported, fallback to text"));
    }

    return obj;
  }).then(function (result) {
    if (result.response.status >= 400) {
      innerDispatch(result.payload, false, result.response);
      var errorMessage = (0, _has["default"])(result.payload, 'message') ? (0, _get["default"])(result.payload, 'message') : (0, _isObject["default"])(result.payload) ? JSON.stringify(result.payload) : result.payload;

      if (result.response.status >= 500) {
        window.rg4js && window.rg4js('send', {
          error: "Server error: ".concat(result.response.status),
          customData: {
            url: url,
            statusCode: result.response.status,
            response: errorMessage
          }
        });
      }

      throw new Error(errorMessage);
    } else {
      innerDispatch(result.payload, true, result.response);
      return {
        payload: result.payload,
        dispatch: dispatch,
        getState: getState
      };
    }
  })["catch"](function (error) {
    // Firefox throws a TypeError when navigating to a page when a request is incomplete
    // we dont want to throw a message when this happends.
    // https://github.com/github/fetch/issues/310
    // https://developer.mozilla.org/nl/docs/Web/JavaScript/Reference/Global_Objects/TypeError
    var dontLog = error.constructor === TypeError; // cdn url retry with non cdn url

    if ((0, _urlHelper.isKnownCdnUrl)(url)) {
      var nonCdnUrl = (0, _urlHelper.convertSiteNameToNonCdnUrl)(url);

      _internalFetch(nonCdnUrl, options, dispatch, getState);
    }

    if (options.onException) {
      options.onException(error, dispatch, getState);
    } else if (!didCallDispatch) {
      // if we abort the request ourselves we have AbortError in the 'name'
      // property of the error. Dont dispatch anything, just cancel the
      // request
      if (error.name !== 'AbortError') {
        innerDispatch({
          message: 'Oops...something went wrong'
        }, false, {}, dontLog);
      }
    } else {
      var errorObjWithDispatch = {
        error: error,
        dispatch: dispatch,
        getState: getState
      };
      throw errorObjWithDispatch;
    }

    return {
      error: error
    };
  });
}
/**
 * Check Authentification headers, this is used in every call to our own backend api,
 * It will redirect to login when a use is logged out, or its session is expired
 *
 * @param {any} response promise
 * @param {string} url the call url, this is not always visible in response in some browsers
 * @returns {any} response promise
 */


function _checkAuthentication(response, url, options) {
  if (response.status === 401) {
    if (options.doNotRedirectToLoginOn401) {
      return response;
    } // Every request will be checked for Authentification
    // Dont redirect to login from a login call


    var loginUrl = (0, _urlHelper.getUrl)(_urlHelper.siteNames.API_LOGIN, '/v1.0/login');
    var signupUrl = (0, _urlHelper.getUrl)(_urlHelper.siteNames.API_LOGIN, '/v1.0/accounts');
    var isLoginUrl = url === loginUrl;
    var isSignupUrl = url === signupUrl;
    var isAccountFeatures = url.indexOf('v1.0/account/features') >= 0;
    var isCreditCardCheck = url.indexOf('credit_card/auth') >= 0; // todo refactor find better solition, to many exceptions here
    // return when its the session token, otherwise you cant access prive routes

    if (url.indexOf('session') !== -1 && (0, _runtimeConfigHelper.getRuntimeConfig)()._app === 'app-store-shop') {
      return response;
    }

    var isWhiteListUrl = url.indexOf('token') !== -1 || isLoginUrl || isSignupUrl || isCreditCardCheck || isAccountFeatures;

    if (onHandle401Request) {
      onHandle401Request(isWhiteListUrl, (0, _urlHelper.getLoginUrl)(), response, url);
    } else {
      if (!isWhiteListUrl) {
        // Return to login paged
        console.warn('FetchHelper._checkAuthentication redirect to login. An api request returned a 401');
        window.location.href = (0, _urlHelper.getLoginUrl)();
      }
    }
  } else if (response.status === 422) {
    // Skip redirect to login page from the login page
    if ((0, _runtimeConfigHelper.getRuntimeConfig)()._app === 'app-login') {
      return response;
    } // When we receive a 422 status code on the token/refresh url we are going to redirect to the login page


    var refreshUrl = (0, _urlHelper.getUrl)(_urlHelper.siteNames.API, '/v1.0/token/refresh');

    if (refreshUrl === url) {
      window.location.href = (0, _urlHelper.getLoginUrl)();
    }
  }

  return response;
}

function setGlobalModifyHeader(cb) {
  if ((0, _isFunction["default"])(cb)) {
    exports.globalModifyHeader = globalModifyHeader = cb;
  }
}
/**
 * set a callback that is triggered if we receive a 401, this overrides the default behavior of navigating to the login page and allows custom behavior
 * @param {function} callback
 */


function setHandle401RequestCallback(callback) {
  onHandle401Request = callback;
}
/**
 * Set a callback that is triggered after we handle a request. This allows custom logic in your application to handle a specific statuscode on all api calls
 * @param {function} callback (statuscode, response)
 */


function setHandleStatusCallback(callback) {
  if ((0, _isFunction["default"])(callback) || (0, _isNil["default"])(callback)) {
    onHandleStatus = callback;
  }
}
/**
 * put json to the given url
 *
 * @function
 * @param {string} url - string
 * @param {object} data, will be send as json
 * @param {object} options, object.key is required.
 * You can add object.extraArguments, these will be available in the reducer when the fetch is completed
 * @returns promise, that will dispatch redux events
 *
 * @memberOf FetchHelper
 */


function putAsJson(url, data, options, headers) {
  var obj = _objectSpread({
    returnType: 'json'
  }, options);

  obj.fetchOptions = {
    method: 'PUT',
    headers: _objectSpread({
      'Content-Type': 'application/json'
    }, headers),
    body: JSON.stringify(data)
  };
  return fetch(url, obj);
}
/**
 * post json to the given url
 *
 * @function
 * @param {string} url - string
 * @param {object} data, will be send as json
 * @param {object} options, object.key is required.
 * You can add object.extraArguments, these will be available in the reducer when the fetch is completed
 * @returns promise, that will dispatch redux events
 *
 * @memberOf FetchHelper
 */


function postAsJson(url, data, options, headers) {
  var obj = _objectSpread({
    returnType: 'json'
  }, options);

  obj.fetchOptions = _objectSpread({}, obj.fetchOptions, {
    method: 'POST',
    headers: _objectSpread({
      'Content-Type': 'application/json'
    }, headers),
    body: JSON.stringify(data)
  });
  return fetch(url, obj);
}

function postAsPlainText(url, data, options, headers) {
  var obj = _objectSpread({
    returnType: 'json'
  }, options);

  obj.fetchOptions = {
    method: 'POST',
    headers: _objectSpread({
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    }, headers),
    body: data
  };

  if (options.modifyHeader) {
    options.modifyHeader(obj.fetchOptions.headers);
  }

  return fetch(url, obj);
}
/**
 * fetch plain text from the given url
 *
 * @function
 * @param {string} url - string
 * @param {object} options
 * @returns promise, that will dispatch redux events
 *
 * @memberOf FetchHelper
 */


function fetchAsPlainText(url, options) {
  var obj = _objectSpread({}, options);

  obj.returnType = 'text';
  return fetch(url, obj);
}
/**
 * delete json to the given url
 *
 * @function
 * @param {string} url - string
 * @param {object} data, will be send as json
 * @param {object} options, object.key is required.
 * You can add object.extraArguments, these will be available in the reducer when the fetch is completed
 * @returns promise, that will dispatch redux events
 *
 * @memberOf FetchHelper
 */


function deleteAsJson(url, data, options, headers) {
  var obj = _objectSpread({
    returnType: 'json'
  }, options);

  obj.fetchOptions = {
    method: 'DELETE',
    headers: _objectSpread({
      'Content-Type': 'application/json'
    }, headers),
    body: JSON.stringify(data),
    extraArguments: options.extraArguments
  };
  return fetch(url, obj);
}
/**
 * fetch json to the given url
 *
 * @function
 * @param {string} url - string
 * @param {object} options, object.key is required.
 * You can add object.extraArguments, these will be available in the reducer when the fetch is completed
 * @returns promise, that will dispatch redux events
 *
 * @memberOf FetchHelper
 */


function fetchAsJson(url, options) {
  var obj = _objectSpread({}, options);

  obj.returnType = 'json';
  return fetch(url, obj);
}
/**
 * fetch - wrapper around isomorphic fetch, that will trigger redux events
 *
 * @function
 * @param {string} url - string
 * @param {object} options, object.key is required.
 * You can add object.extraArguments, these will be available in the reducer when the fetch is completed
 * @returns promise, that will dispatch redux events
 *
 * @memberOf FetchHelper
 */


function fetch(url, options) {
  if (!options || !options.key) {
    throw new Error('Missing option.key Attribute');
  }

  if (options.fetchOptions && options.fetchOptions.method && options.fetchOptions.method !== 'GET') {
    (0, _useDataApi.clearCache)();
  }

  return function (dispatch, getState) {
    return _internalFetch(url, options, dispatch, getState);
  };
}